import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import Modal from '@material-ui/core/Modal';
import { reactGaEvent } from "examsbook-react-sdk/actions/Common";
import { requestNewOtp, verifyOtp } from 'examsbook-react-sdk/services/userService';
import useTranslations from "examsbook-react-sdk/custom-hooks/useTranslations";

/**
 * Otp verification model
 * @param props
 * @returns {*}
 * @constructor
 */
function OtpVerificationModel(props) {
    const t = useTranslations();
    const dispatch = useDispatch();
    const [ otp, setOtp ] = useState('');
    const [ errorMessage, setErrorMessage ] = useState('');

    function isValidOtp() {
        //verifyOtp
        if (otp) {
            verifyOtp({
                    "otp": otp
                }
            ).then((response) => {
                if (response.status === 200) {
                    //otp verified.
                    dispatch({
                        type: 'VERIFY_OTP'
                    });
                    props.closeModel();
                } else {
                    //show error
                    setErrorMessage(response.message);
                    if (response.message === 'you have reached maximum attempts, please retry with new OTP') {
                        setTimeout(() => {
                            props.closeModel();
                        }, 500);
                    }
                }
            }).catch((error) => {
                console.log('error----->', error);
            });
        }
    }

    function isOtpMeetRequirements() {
        return (!otp || otp.length === 6);
    }

    /**
     * Function to close model.
     * clear state and close model.
     */
    function closeVerificationModel() {
        //clear
        setOtp('');
        setErrorMessage('');
        props.closeModel();
    }

    // request for new otp, if user haven't got an OTP.
    function requestForOtp() {
        if (props.mobileNumber) {
            reactGaEvent("Phone number verification", "OTP requested");
            //clear error and otp.
            setOtp('');
            setErrorMessage('');
            requestNewOtp(props.mobileNumber).then((response) => {
            });
        }
    }

    return (
        <Modal className="password-modal exam-modal contact-modal edit-modal"
               aria-labelledby="simple-modal-title"
               aria-describedby="simple-modal-description"
               open={props.isOtpModelOpen}
               onClose={props.closeModel}>
            <DialogContent>
                <div>
                    <div className="otp-field">
                        <TextField className="text-field"
                                   label={t('OTP')}
                                   type="number"
                                   error={!isOtpMeetRequirements()}
                                   inputProps={{
                                       maxLength: 6,
                                   }}
                                   onInput={(e) => {
                                       e.target.value = Math.max(0, parseInt(e.target.value, 10)).toString().slice(0, 6);
                                   }}
                                   value={otp}
                                   onChange={(event) => {
                                       setOtp(event.target.value);
                                   }}
                                   margin="normal"/>
                        <div className="button-submit resend-otp">
                            {
                                errorMessage ?
                                    <a href="javascript:void(0)" onClick={requestForOtp}>{t('RESEND_OTP')}</a> : ''
                            }
                        </div>
                    </div>
                    <span>{errorMessage}</span>

                    <div className="button-submit">
                        <Button onClick={isValidOtp} disabled={!(otp && otp.length === 6)}>
                            {t('VERIFY_OTP')}
                        </Button>
                    </div>
                    <div className="edit-data close-data"
                         onClick={closeVerificationModel}>
                        <i className="fa fa-close"/>
                    </div>
                </div>
            </DialogContent>
        </Modal>
    );
}

export default OtpVerificationModel;
